import { useState } from "react"

import { cn } from "@/lib/utils"
import type { QuizStep } from "../../types"
import { matchesPattern } from "./step-contract"

interface Props {
  step: QuizStep
  value: string
  onChange: (value: string) => void
}

export function InputStep({ step, value, onChange }: Props) {
  const [touched, setTouched] = useState(false)
  const showError = touched && value.length > 0 && !matchesPattern(value, step)

  return (
    <div className="space-y-2">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => setTouched(true)}
        placeholder={step.placeholder || "Enter your answer"}
        className={cn(
          "h-12 w-full rounded-xl bg-purple-light/10 px-3 text-base font-medium text-purple-light outline-none transition-colors placeholder:text-purple-light/40",
          showError
            ? "ring-1 ring-peach"
            : "focus:ring-2 focus:ring-main-purple focus:ring-inset",
        )}
        autoFocus
      />
      {showError && step.validation && (
        <p className="text-sm text-peach">{step.validation.message}</p>
      )}
    </div>
  )
}
